export default "__VITE_ASSET__DOtZssU7__"